import * as React from 'react'
import { connect } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router'

import * as qs from 'query-string'

import Moment from 'react-moment'
import * as CurrencyFormat from 'react-currency-format'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'

import { RootState } from '../store/rootReducer'
import { Claim } from '../lib/interfaces/Claim.interface'
import { EmployeeFilterParams } from '../lib/interfaces/Employee.interface'
import { User, hasPermission, hasAnyPermission } from '../lib/interfaces/User.interface'
import { ApplicationFilterParameters } from '../lib/interfaces/ApplicationFilterParameters.interface'

import NavSearch from './NavSearch.component'
import LocationSelect from '../common/LocationSelect.component'
import RoleAssumptionModal from './employees/components/RoleAssumption.modal'

import * as authActions from '../store/auth/actions'
import * as accidentsActions from '../store/accidents/actions'
import * as applicationsActions from '../store/applications/actions'

import { formatName } from 'src/lib/helpers/format'

const get = require('lodash/get')
const isEmpty = require('lodash/isEmpty')
const debounce = require('lodash/debounce')

type Status = 'open' | 'collapsed'

interface NavProps extends RouteComponentProps {
  user: User,
  userSearch: boolean,
  onLogout: () => void,
  sidebarStatus?: Status,
  accidentSearch: boolean
  applicationSearch: boolean
  isSearchingClaims: boolean
  onToggleSidebar: () => void
  claimSearchResults?: Claim[]
  resetClaimsSearch: () => void
  isFetchingApplications: boolean
  searchClaims: (params: any) => void
  assumeRoleFromUser: (user?: User) => void
  applicationFilterParams: ApplicationFilterParameters
  setApplicationsFilterParams: (filterParams: ApplicationFilterParameters) => void
}

type NavState = {
  search: string
  location?: number
  dropdownStatus: Status
  roleAssumptionModalOpen: boolean
}

class Nav extends React.PureComponent<NavProps> {
  state: NavState = {
    search: '',
    dropdownStatus: 'collapsed',
    roleAssumptionModalOpen: false
  }

  debounceAccidentsSearch = debounce(() => {
    const { search } = this.state
    const { searchClaims } = this.props

    if (!isEmpty(search) && search.length >= 3) {
      searchClaims({ query: search })
    }
  }, 300)

  handleDropdownToggle = () => {
    this.setState((state: NavState) => ({
      dropdownStatus: (state.dropdownStatus !== 'open') ? 'open' : 'collapsed'
    }))
  }

  handleLogout = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    this.props.onLogout()
  }

  handleRoleAssumption = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    this.setState({ roleAssumptionModalOpen: true })
  }

  handleResetRole = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    this.props.assumeRoleFromUser(undefined)
  }

  handleEmployeeSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const { history } = this.props
    const { search, location } = this.state

    const query: EmployeeFilterParams = {}
    if (search && search.length > 0) { query.search = search }
    if (location) { query.location = location }

    const queryString = qs.stringify(query)
    history.push(`/employees/search?${queryString}`)
  }

  handleApplicationSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    console.log('Vou atualizar o filter params')
    const applicationFilterParams = { ...this.props.applicationFilterParams }
    applicationFilterParams.search = this.state.search
    this.props.setApplicationsFilterParams(applicationFilterParams)
    // this.props.history.push(`/applications?${qs.stringify(applicationFilterParams)}`)
  }

  handleSearchValueChange = (propertyName: string, value) => {
    this.setState({ [propertyName]: value })
  }

  handleAccidentSearchValueChange = (value: string) => {
    this.setState({ search: value }, () => {
      this.debounceAccidentsSearch()

      if (!value || value.length < 3) {
        this.props.resetClaimsSearch()
      }
    })
  }

  handleSelectClaim = (claim: Claim) => {
    const { history } = this.props

    const accidentId = get(claim, 'accident.id')
    if (accidentId) {
      history.push(`/accidents/${accidentId}`)
    }
  }

  renderClaimSuggestion(claim: Claim, isHighlighted: boolean) {
    let vin = 'N/A'
    if (claim.vehicleVin) {
      const rawVin = claim.vehicleVin
      if (rawVin.length < 6) {
        vin = rawVin
      }
      else {
        vin = rawVin.substr(rawVin.length - 6, rawVin.length - 1)
      }
    }

    const employeeId = get(claim, 'employee.id')
    const employeeName = formatName(claim.employee)

    let employee
    if (employeeName && employeeName.length > 0) {
      employee = `${employeeName} (${employeeId})`
    }
    else {
      employee = employeeId ? `${employeeId}` : '-'
    }

    const claimStatusName = get(claim, 'claimStatus.name')

    return (
      <div className="ggnavsearch-suggestion p-2" style={{ backgroundColor: isHighlighted ? 'rgba(0, 0, 0, 0.1)' : 'white' }}>
        <div className="d-flex align-items-center text-left">
          <span className="ellipsize-left"><b>VIN: </b>{vin || '-'}</span>
          <div className="flex-grow-1 d-flex align-items-center justify-content-end">
            {claimStatusName && (
              <span
                style={{ fontSize: '10px' }}
                className="badge badge-primary align-self-end"
              >
                {claimStatusName}
              </span>
            )}

            <span
              style={{ fontSize: '11px' }}
              className="badge badge-primary align-self-end ml-1"
            >
              {get(claim, 'accident.locationPosition.location.code', 'N/A')}
            </span>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between text-left">
          <span><b>ERAC: </b>{claim.enterpriseId || 'N/A'}</span>

          <span className="font-weight-bold">
            <CurrencyFormat
              prefix="$"
              decimalScale={2}
              displayType="text"
              value={claim.damage}
              thousandSeparator={true}
              fixedDecimalScale={true}
            />
          </span>
        </div>

        <div className="d-flex align-items-center justify-content-between text-left">
          <span
            style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
          >
            <b>Employee: </b>{employee}
          </span>

          {/* <span><Moment date={claim.lossDate} format="MM.DD.YYYY" /></span> */}
        </div>
      </div>
    )
  }

  render() {
    const { search, location, dropdownStatus, roleAssumptionModalOpen } = this.state
    const {
      user,
      userSearch,
      sidebarStatus,
      accidentSearch,
      onToggleSidebar,
      applicationSearch,
      isSearchingClaims,
      claimSearchResults,
      isFetchingApplications,
      applicationFilterParams
    } = this.props

    return (
      <nav id="ggnav" className="d-flex align-items-center justify-content-between">
        {hasPermission(user, 'ROLE_ADMIN') && 
          <RoleAssumptionModal open={roleAssumptionModalOpen} onToggle={() => this.setState({ roleAssumptionModalOpen: false })} />
        }
        <div className="flex-grow-1">
          <button className="btn btn-primary ml-3" onClick={onToggleSidebar}>
            <FontAwesomeIcon className="ggnav-toggle"
              icon={["fas", "angle-left"]}
              flip={(sidebarStatus === 'collapsed') ? 'horizontal' : undefined}
            />
          </button>
        </div>

        <div className="d-flex align-items-center">
          {userSearch
            ? (
              <form className="d-flex align-items-center mr-3" onSubmit={this.handleEmployeeSearch}>
                <NavSearch
                  value={search}
                  className="mr-3"
                  style={{ width: '220px' }}
                  onChange={value => this.handleSearchValueChange('search', value)}
                />

                <LocationSelect
                  type="orange"
                  value={location}
                  style={{ width: '150px' }}
                  onChange={value => this.handleSearchValueChange('location', value)}
                />
              </form>
            )
            : accidentSearch && hasAnyPermission(user, ['ROLE_ACCIDENT_ADMIN', 'ROLE_CITY_MANAGER'])
              ? (
                <div className="d-flex align-items-center mr-3">
                  <NavSearch
                    value={search}
                    className="mr-3"
                    enableSuggestions
                    style={{ width: '300px' }}
                    isLoading={isSearchingClaims}
                    suggestions={claimSearchResults}
                    renderSuggestion={this.renderClaimSuggestion}
                    onChange={value => this.handleAccidentSearchValueChange(value)}
                    onSelect={(id: number, item: Claim) => this.handleSelectClaim(item)}
                  />
                </div>
              )
              : applicationSearch && hasAnyPermission(user, ['ROLE_JOB_APPLICATION', 'ROLE_APPLICATION_ADMIN'])
                ? (
                  <form className="d-flex align-items-center mr-3" onSubmit={this.handleApplicationSearch}>
                    <NavSearch
                      value={search}
                      style={{ width: '300px' }}
                      isLoading={isFetchingApplications}
                      onChange={value => this.handleSearchValueChange('search', value)}
                    />
                  </form>
                )
                : null
          }

          <Dropdown isOpen={dropdownStatus === 'open'} toggle={this.handleDropdownToggle}>
            <DropdownToggle className="ggnav-userdropdown-btn rounded-0 text-capitalize" color="primary">
              <img className="ggnav-userdropdown-avatar rounded-circle mr-2 border border-dark" src={user.profileImageUrl} />
              <div className="d-flex flex-column align-items-start">
                {formatName(user.employee)}

                {user.assumingRoleFrom && (
                  <small style={{ marginTop: '-5px' }}>Assuming <b>{formatName(user.assumingRoleFrom.employee)}</b></small>
                )}
              </div>

              <FontAwesomeIcon className="ggnav-toggle ml-3"
                icon={["fas", "angle-down"]}
                flip={(sidebarStatus === 'collapsed') ? 'horizontal' : undefined}
              />
            </DropdownToggle>
            <DropdownMenu className="rounded-0">
              {!user.assumingRoleFrom && hasPermission(user, 'ROLE_ADMIN') && (
                <DropdownItem href="" onClick={this.handleRoleAssumption}>
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon className="mr-2" icon={['fas', 'glasses']} />
                    Assume role...
                  </div>
                </DropdownItem>
              )}

              {user.assumingRoleFrom && (
                <DropdownItem href="" onClick={this.handleResetRole}>
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon className="mr-2" icon={['fas', 'glasses']} />
                    Reset role
                  </div>
                </DropdownItem>
              )}

              <DropdownItem href="" onClick={this.handleLogout}>
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon className="mr-2" icon={['fas', 'sign-out-alt']} />
                  Logout
                </div>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </nav>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  isSearchingClaims: state.accidents.isSearchingClaims,
  claimSearchResults: state.accidents.claimSearchResults,
  applicationFilterParams: state.applications.filterParams,
  isFetchingApplications: state.applications.isFetchingApplications
})

const mapDispatchToProps = (dispatch) => ({
  resetClaimsSearch: () => dispatch(accidentsActions.resetClaimsSearch()),
  searchClaims: (params: any) => dispatch(accidentsActions.searchClaims(params)),
  assumeRoleFromUser: (user?: User) => dispatch(authActions.assumeRoleFromUser(user)),
  setApplicationsFilterParams: (filterParams: ApplicationFilterParameters) =>
    dispatch(applicationsActions.setApplicationsFilterParams(filterParams)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Nav))



// WEBPACK FOOTER //
// ./src/routes/Nav.component.tsx